"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _react = _interopRequireWildcard(require("react"));

var _ReactStaticPage = require("../../../../../react-static/page/ReactStaticPage");

var _Breadcrumbs = require("../../../../../components/Breadcrumb/Breadcrumbs");

var _mobxReact = require("mobx-react");

var _reactStatic = require("react-static");

var _PlanForTiles = require("../../../planFor/PlanForTiles");

var _PlanFor = require("./PlanFor");

var _Packing = require("../Packing");

var _Core = require("../../../../../components/Core");

var _class;

var PlanForPage = (0, _mobxReact.observer)(_class =
/*#__PURE__*/
function (_Component) {
  (0, _inheritsLoose2.default)(PlanForPage, _Component);

  function PlanForPage(props) {
    return _Component.call(this, props) || this;
  }

  var _proto = PlanForPage.prototype;

  _proto.render = function render() {
    var planFors = this.props.planFors;
    var title = _PlanFor.PackingPlanForTitle;
    return _react.default.createElement(_ReactStaticPage.ReactStaticPage, (0, _extends2.default)({
      title: title
    }, this.props), _react.default.createElement(_Breadcrumbs.Breadcrumbs, {
      items: [{
        label: _Packing.PackingTitle
      }]
    }), _react.default.createElement("p", null, "Select what aspect you would like to plan for. You will be able to view related items of that travel aspect and potentially add them to a travel packing list:"), _react.default.createElement(_Core.Box, {
      mb: 3
    }, _react.default.createElement(_PlanForTiles.PlanForTiles, {
      planFors: planFors
    })), _react.default.createElement("h2", null, "Packing List by Travel Aspect"), _react.default.createElement("p", null, "One of the ways to make a packing list is to browse each aspect and select the items you might need to take. This may work well if you have an idea of the things you plan on doing on your trip or are looking for some ideas. You will also be able to generate an online packing list by selecting aspects that interest you and we will recommend what you might like to add."), _react.default.createElement("h3", null, "Incoming Feature"), _react.default.createElement("p", null, "Create your own account and add the items you need to make your custom online packing lists."));
  };

  return PlanForPage;
}(_react.Component)) || _class;

var _default = (0, _reactStatic.withRouteData)(PlanForPage);

exports.default = _default;